import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue";
const _hoisted_1 = {
  style: {
    "min-width": "1560px"
  }
};
const _hoisted_2 = {
  style: {
    "text-align": "center",
    "margin": "30px 0"
  }
};
const _hoisted_3 = {
  key: 0
};
const _hoisted_4 = {
  style: {
    "display": "flex",
    "justify-content": "center",
    "width": "100%"
  }
};
const _hoisted_5 = ["innerHTML"];
const _hoisted_6 = {
  key: 0,
  style: {
    "text-align": "center",
    "font-size": "16px"
  }
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [$setup.get_data.id != 4 ? (_openBlock(), _createElementBlock("h1", _hoisted_3, _toDisplayString($setup.get_data.benefitName), 1)) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_4, [_createElementVNode("p", {
    class: "benefit-details-img",
    innerHTML: $setup.get_data.benefitDetails,
    style: {
      "margin-bottom": "100px",
      "width": "80%"
    }
  }, null, 8, _hoisted_5)]), $setup.route.params.id == 4 ? (_openBlock(), _createElementBlock("div", _hoisted_6, [_cache[1] || (_cache[1] = _createElementVNode("span", null, "想要了解更多，点击", -1)), _createElementVNode("span", {
    style: {
      "color": "#28ABC4",
      "text-decoration": "underline",
      "cursor": "pointer"
    },
    onClick: _cache[0] || (_cache[0] = (...args) => $setup.call && $setup.call(...args))
  }, "添加客服")])) : _createCommentVNode("", true)]);
}